/* eslint-disable react/destructuring-assignment */
import { Optional } from '~/common/types'
import { Search, SearchInputProps } from '~/components/v2/Search'
import { useActionBarContext } from './ActionBar.hook'

export const ActionBarSearch = ({
  value: _value,
  onChange: _onChange,
  ...props
}: Optional<SearchInputProps, 'value' | 'onChange'>) => {
  const { search: searchContext } = useActionBarContext()

  const value = _value ?? searchContext?.value ?? ''
  const onChange = (value: string) => {
    _onChange?.(value)
    searchContext?.onChange(value)
  }

  return <Search data-action-bar-search data-testid="action-bar-search" value={value} onChange={onChange} {...props} />
}
